export default __webpack_public_path__ + "static/media/Glad to hear.00691f96.mp3";